import YearListingView from '@/views/admin/years/YearsListingView.vue';
import YearCreateView from '@/views/admin/years/YearCreateView.vue';
import YearDetailView from '@/views/admin/years/YearDetailView.vue';
import TeamYearDetailView from '@/views/admin/teams/TeamYearDetailView.vue';
import YearTeamsIncompleteView from '@/views/admin/years/YearTeamsIncompleteView.vue';

export const adminYearRoutes = [
  {
    path: '/admin/years',
    name: 'AdminYearListing',
    component: YearListingView,
    meta: { guest: false },
  },
  {
    path: '/admin/year/:yearId/:tabName?',
    name: 'AdminYearEdit',
    component: YearDetailView,
    meta: { guest: false },
  },
  {
    path: '/admin/year/:yearId/team/:teamId/:tabName?',
    name: 'AdminYearTeamDetailView',
    component: TeamYearDetailView,
    meta: { guest: false },
  },
  {
    path: '/admin/years/create',
    name: 'AdminYearCreate',
    component: YearCreateView,
    meta: { guest: false },
  },
  {
    path: '/admin/year/:yearId/incomplete',
    name: 'AdminYearTeamIncomplete',
    component: YearTeamsIncompleteView,
    meta: { guest: false },
  },
];
